import React from 'react';
import Chart from './Chart';
import './index.scss';
import DropDownCode from './DropDownCode';
import DropDownRate from './DropDownRate';
import TimeRange from './TimeRange';
import { connect } from 'react-redux';
import ExportValuation from './ExportValuation';

class Valuation extends React.Component {
  render() {
    return (
      <div className="index-valuation-wrapper d-flex flex-column flex-fill">
        <div className="valuation-filter pl-20 pr-20 mb-10 d-flex">
          <div className="list-filter float-left">
            <div className="line-drop mr-10">
              <DropDownCode />
            </div>
            <div className="line-drop">
              <DropDownRate />
            </div>
          </div>
          <div
            className="tabs-right-top float-right ml-10 w-100"
            style={{
              justifyContent: 'flex-end',
            }}
          >
            <TimeRange />
          </div>
        </div>
        <div className="pl-20 pr-20">
          <div className="valuation-filter">
            <div className="tabs-right-top float-right invisible">
              <ExportValuation />
            </div>
          </div>
          <div className="clearfix" />
          <div className="mt-10">
            <Chart />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  i18n: state.i18n,
});

export default connect(mapStateToProps)(Valuation);
